module.exports = __webpack_public_path__ + "img/basic-info.deef68e6.png";